// src/pages/ServiceDetailPage.js
import React, { useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { servicesData } from '../data/servicesData'; // Veriyi çekiyoruz
import { ArrowLeft, Phone } from 'lucide-react';
import styles from '../css/ServiceDetail.module.css';

const ServiceDetailPage = () => {
  const { slug } = useParams(); // URL'deki 'motor-revizyon' kısmını alır
  const service = servicesData.find(s => s.slug === slug);

  // Sayfa açıldığında en tepeye kaydır (React Router bazen aşağıda başlatır)
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [slug]);

  if (!service) {
    return <div style={{color:'white', padding:'100px', textAlign:'center'}}>Hizmet bulunamadı.</div>;
  }

  return (
    <div className={styles.detailContainer}>
      {/* Üst Banner */}
      <div className={styles.heroBanner}>
        <div className={styles.overlay}></div>
        <div className={styles.bannerContent}>
          <div className={styles.iconBox}>{service.icon}</div>
          <h1>{service.title}</h1>
        </div>
      </div>

      <div className={styles.contentWrapper}>
        <Link to="/" className={styles.backBtn}>
           <ArrowLeft size={20} /> Anasayfaya Dön
        </Link>
        
        {/* HTML içeriğini güvenli bir şekilde basıyoruz */}
        <div 
          className={styles.article}
          dangerouslySetInnerHTML={{ __html: service.content }} 
        />

        <div className={styles.ctaBox}>
          <h3>Bu hizmet için fiyat almak ister misiniz?</h3>
          <p>Motorunuzun marka ve modelini bize WhatsApp'tan atın, hemen fiyat verelim.</p>
          <a href="tel:+905426429466" className={styles.whatsappBtn}>
             <Phone size={18} /> Hemen Ara & Fiyat Al
          </a>
        </div>
      </div>
    </div>
  );
};

export default ServiceDetailPage;